import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import theme from "../../theme";

export const ReactSwiper = styled(Swiper)`
    color: ${theme.colors.white};
    .swiper-pagination {
        bottom: 48px !important;
    }
    .swiper-pagination .swiper-pagination-bullet {
        width: 30px;
        height: 5px;
        border-radius: 4px;
    }

    .swiper-pagination .swiper-pagination-bullet-active {
        background-color: #fff;
    }
`;

export const ReactSwiperSlider = styled(SwiperSlide)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ReactSwiperSliderCard = styled.div<{
    img: string;
    imgGradient: string;
    imgPosition: string;
}>`
    position: relative;
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background: ${({ imgGradient }) => imgGradient}, url(${({ img }) => img});
    background-size: cover;
    background-position: ${({ imgPosition }) => imgPosition};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
`;

export const ImgOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.5;
    background-color: blue;
    height: 100%;
    width: 100%;
`;

export const Text = styled.p`
    font-family: "Montserrat", sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0.02em;
    text-align: center;
    margin-bottom: 6rem;
    color: ${theme.colors.white};
`;
